export const environment = {
  API_KEY_SPREADSHEETS: 'AIzaSyA5gpwyK0aK3DRxyHnmtNmTLBG9R73Ckwk',
  baseUrl: 'http://mcdt-portal-usuario-test.s3-website-us-east-1.amazonaws.com/',
  production: false,
  API_KEY: 'D-WDwP%yV3tPik@eRbTKKLXv*l&o$Ksh',
  API_BASE_URL: 'https://api-dev.mejorcdt.com/wlcolte/',
  version: 'v1/',
  API_NEW_PDF: 'https://6gcpzr6ne1.execute-api.us-east-1.amazonaws.com/test/new-pdf',
  API_BANK_RATES: 'https://6gcpzr6ne1.execute-api.us-east-1.amazonaws.com/test/bank-rates',
  API_ADELAIDA: 'https://723zjxdku1.execute-api.us-east-1.amazonaws.com/tes/',
  S3_STATIC_FILES: 'https://mcdt-static-tes.s3.amazonaws.com',
  GTA_TRACKING_CODE: 'GTM-MZFSNS2',
  SECRET_KEY: 'aidLPD4pwTsVNBpyWdlIn4_4RW6hUl87A9UhIAoCyZ8=',
  BRAND: 'coltefinanciera',
  RECAPTCHA_V3_SITE_KEY: '6LdmfksrAAAAAO6BNVy1dg3e86V03bI63SeCgRI2',
  ACTIVE_RECAPTCHA: true,
  KEY_ENCRIPTION: '9fe12117-2d84-4cf2-806e-32545e0a455c',
  ENVIRONMENT_NAME: 'test',
  HAS_UUID_REMOVE_RTIR: 'd3f2220e-4acc-4156-935d-bfcf3f80adf2',
  HOST: 'ltest.mejorcdt.com',
  GOOGLE_MAPS_API_KEY: 'AIzaSyDcNj3ZrY9iivwGqtmmEDmgIi_1Wdn_Cb8',
  LEGAL: {
    LINK_POLITCA_PRIVACIDAD_DATOS_PERSONALES:
      'https://www.coltefinanciera.com.co/aviso-de-privacidad-para-el-tratamiento-de-datos-personales/',
  },
};
